import { render, staticRenderFns } from "./estoque.vue?vue&type=template&id=0981284c&scoped=true&"
import script from "./estoque.vue?vue&type=script&lang=js&"
export * from "./estoque.vue?vue&type=script&lang=js&"
import style0 from "./estoque.vue?vue&type=style&index=0&id=0981284c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0981284c",
  null
  
)

export default component.exports